import React from 'react';
import Timer from '../timer/Timer';
export default function Navbar({
  special,
  minutesDisplay,
  secondsDisplay,
  hidden,
}) {
  return (
    <div className="nav-create">
      <div className="image-container">
        <img
          className=""
          src={process.env.PUBLIC_URL + '/assets/images/kaya-logo-new.png'}
          alt=""
        />{' '}
      </div>

      {hidden ? (
        <></>
      ) : !hidden && !special ? (
        <Timer
          minutesDisplay={minutesDisplay}
          secondsDisplay={secondsDisplay}
        />
      ) : (
        <>This will take few minutes</>
      )}
    </div>
  );
}
